import Layout from 'components/common/Layout'
import Topic from 'components/Search/Topic'
import { useQuery } from 'hooks'
import { useEffect } from 'react'
import {
  useParams
} from 'react-router-dom'
import Seo from './Seo'

export default ({ setSearchTerm, searchLoader, turnOnLoaderSearch }) => {
  const { term } = useParams()

  const query = useQuery('query')
  useEffect(() => {
    const param = term || query
    param && setSearchTerm(param)
    turnOnLoaderSearch()
  }, [query])

  return (
    <Layout hideSupport>
      <Seo />
      <Topic loading={searchLoader} />
    </Layout>
  )
}
